import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66facc7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ctrl-bet-box-group-root" }
const _hoisted_2 = {
  key: 0,
  class: "ctrl-bet-box-group"
}
const _hoisted_3 = {
  key: 0,
  class: "bet-view-r"
}
const _hoisted_4 = { class: "bet-view-r" }
const _hoisted_5 = { class: "bet-view-r" }
const _hoisted_6 = {
  key: 1,
  class: "ctrl-bet-box-group"
}
const _hoisted_7 = { class: "bet-view-r" }
const _hoisted_8 = { class: "bet-view-r" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 4,
  class: "btn-group"
}
const _hoisted_11 = { class: "toast-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ctrl_bet_box = _resolveComponent("ctrl-bet-box")!
  const _component_bet_start_stop_pop = _resolveComponent("bet-start-stop-pop")!
  const _component_cancel_bet = _resolveComponent("cancel-bet")!
  const _component_confirm_bet = _resolveComponent("confirm-bet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.gameType === 'G002')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.playMode === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_ctrl_bet_box, {
                  class: "bet-view-r-item",
                  color: 3,
                  label: _ctx.t('bettype.bear8'),
                  ratio: "1:25",
                  totalBet: _ctx.bearEightAmount,
                  onPlaceBet: _ctx.placeBet,
                  betType: 10,
                  tempBet: _ctx.tempBear8Bet,
                  confirmedBet: _ctx.bear8Bet,
                  width: 70,
                  height: 60,
                  mWidth: 70,
                  mHeight: 45,
                  ref: "bear8Box",
                  "is-gray-mode": !_ctx.allowBetOnB8andD7,
                  "allow-bet": _ctx.mData?.status === 1,
                  onOnError: _ctx.handleToastMessage,
                  "show-flashing-bg": _ctx.GWin === 8 || _ctx.GWin === 81 || _ctx.GWin === 82 || _ctx.GWin === 83
                }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "is-gray-mode", "allow-bet", "onOnError", "show-flashing-bg"]),
                _createVNode(_component_ctrl_bet_box, {
                  class: "bet-view-r-item",
                  color: 4,
                  label: _ctx.t('bettype.smalltiger'),
                  ratio: "1:22",
                  totalBet: _ctx.smallTigerAmount,
                  onPlaceBet: _ctx.placeBet,
                  betType: 11,
                  tempBet: _ctx.tempSmallTigerBet,
                  confirmedBet: _ctx.smallTigerBet,
                  width: 70,
                  height: 60,
                  mWidth: 70,
                  mHeight: 45,
                  ref: "smallTigerBox",
                  "is-gray-mode": _ctx.isSmallTigerGray,
                  "allow-bet": _ctx.mData?.status === 1,
                  "error-message": _ctx.smallTigerGrayError,
                  onOnError: _ctx.handleToastMessage,
                  "show-flashing-bg": _ctx.GWin === 10 || _ctx.GWin === 101 || _ctx.GWin === 102 || _ctx.GWin === 103
                }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "is-gray-mode", "allow-bet", "error-message", "onOnError", "show-flashing-bg"]),
                _createVNode(_component_ctrl_bet_box, {
                  class: "bet-view-r-item",
                  color: 4,
                  label: _ctx.t('bettype.bigtiger'),
                  ratio: "1:50",
                  totalBet: _ctx.bigTigerAmount,
                  onPlaceBet: _ctx.placeBet,
                  betType: 12,
                  tempBet: _ctx.tempBigTigerBet,
                  confirmedBet: _ctx.bigTigerBet,
                  width: 70,
                  height: 60,
                  mWidth: 70,
                  mHeight: 45,
                  ref: "bigTigerBox",
                  "is-gray-mode": _ctx.isBigTigerGray,
                  "allow-bet": _ctx.mData?.status === 1,
                  "error-message": _ctx.bigTigerGrayError,
                  onOnError: _ctx.handleToastMessage,
                  "show-flashing-bg": _ctx.GWin === 9 || _ctx.GWin === 91 || _ctx.GWin === 92 || _ctx.GWin === 93
                }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "is-gray-mode", "allow-bet", "error-message", "onOnError", "show-flashing-bg"]),
                _createVNode(_component_ctrl_bet_box, {
                  class: "bet-view-r-item",
                  color: 1,
                  label: _ctx.t('bettype.dragon7'),
                  ratio: "1:40",
                  totalBet: _ctx.dragonSevenAmount,
                  onPlaceBet: _ctx.placeBet,
                  betType: 13,
                  tempBet: _ctx.tempDragon7Bet,
                  confirmedBet: _ctx.dragon7Bet,
                  width: 70,
                  height: 60,
                  mWidth: 70,
                  mHeight: 45,
                  ref: "dragon7Box",
                  "is-gray-mode": !_ctx.allowBetOnB8andD7,
                  "allow-bet": _ctx.mData?.status === 1,
                  onOnError: _ctx.handleToastMessage,
                  "show-flashing-bg": _ctx.GWin === 7 || _ctx.GWin === 71 || _ctx.GWin === 72 || _ctx.GWin === 73
                }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "is-gray-mode", "allow-bet", "onOnError", "show-flashing-bg"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 3,
              label: _ctx.t('game.playerpair'),
              ratio: "1:11",
              totalBet: _ctx.playerPairAmount,
              onPlaceBet: _ctx.placeBet,
              betType: 6,
              tempBet: _ctx.tempPpBet,
              confirmedBet: _ctx.ppBet,
              width: 100,
              height: 60,
              mWidth: 95,
              mHeight: 45,
              ref: "playerPBox",
              "show-flashing-bg": _ctx.isBluePair
            }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "show-flashing-bg"]),
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 2,
              label: _ctx.t('game.tie'),
              ratio: "1:8",
              totalBet: _ctx.tieTotal,
              onPlaceBet: _ctx.placeBet,
              betType: 2,
              tempBet: _ctx.tempTBet,
              confirmedBet: _ctx.tBet,
              width: 100,
              height: 60,
              mWidth: 95,
              mHeight: 45,
              ref: "tieBox",
              "show-flashing-bg": _ctx.isTieWin
            }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "show-flashing-bg"]),
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 1,
              label: _ctx.t('game.bankerpair'),
              ratio: "1:11",
              totalBet: _ctx.bankerPairAmount,
              onPlaceBet: _ctx.placeBet,
              betType: 7,
              tempBet: _ctx.tempBpBet,
              confirmedBet: _ctx.bpBet,
              width: 100,
              height: 60,
              mWidth: 95,
              mHeight: 45,
              ref: "bankerPBox",
              "show-flashing-bg": _ctx.isRedPair
            }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "show-flashing-bg"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 3,
              label: _ctx.t('game.player'),
              ratio: "1:1",
              totalBet: _ctx.playerTotal,
              onPlaceBet: _ctx.placeBet,
              betType: 1,
              tempBet: _ctx.tempPBet,
              confirmedBet: _ctx.pBet,
              width: 100,
              height: 60,
              mWidth: 95,
              mHeight: 45,
              ref: "playerBox",
              "show-flashing-bg": _ctx.isBlueWin
            }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "show-flashing-bg"]),
            (_ctx.playMode === 2)
              ? (_openBlock(), _createBlock(_component_ctrl_bet_box, {
                  key: 0,
                  class: "bet-view-r-item",
                  color: 4,
                  label: _ctx.t('bettype.super6'),
                  ratio: "1:12",
                  totalBet: _ctx.superSixAmount,
                  onPlaceBet: _ctx.placeBet,
                  betType: 9,
                  tempBet: _ctx.tempSuper6Bet,
                  confirmedBet: _ctx.super6Bet,
                  width: 100,
                  height: 60,
                  mWidth: 95,
                  mHeight: 45,
                  ref: "super6Box",
                  "is-gray-mode": _ctx.isSuper6Gray,
                  "allow-bet": _ctx.mData?.status === 1,
                  "error-message": _ctx.super6GrayError,
                  onOnError: _ctx.handleToastMessage,
                  "show-flashing-bg": _ctx.GWin === 9 ||
                        _ctx.GWin === 91 ||
                        _ctx.GWin === 92 ||
                        _ctx.GWin === 93 ||
                        _ctx.GWin === 10 ||
                        _ctx.GWin === 101 ||
                        _ctx.GWin === 102 ||
                        _ctx.GWin === 103
                }, null, 8, ["label", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "is-gray-mode", "allow-bet", "error-message", "onOnError", "show-flashing-bg"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ctrl_bet_box, {
              class: "bet-view-r-item",
              color: 1,
              label: _ctx.t('game.banker'),
              ratio: _ctx.isFreeBaccarat ? '1:1' : '1:0.95',
              totalBet: _ctx.bankerTotal,
              onPlaceBet: _ctx.placeBet,
              betType: 0,
              tempBet: _ctx.tempBBet,
              confirmedBet: _ctx.bBet,
              width: 100,
              height: 60,
              mWidth: 95,
              mHeight: 45,
              ref: "bankerBox",
              "show-flashing-bg": _ctx.isRedWin
            }, null, 8, ["label", "ratio", "totalBet", "onPlaceBet", "tempBet", "confirmedBet", "show-flashing-bg"])
          ])
        ]))
      : (_ctx.gameType === 'G003')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ctrl_bet_box, {
                class: "bet-view-r-item",
                color: 2,
                label: _ctx.t('game.tie'),
                ratio: "1:8",
                onPlaceBet: _ctx.placeBet,
                tempBet: _ctx.tempTBet,
                totalBet: _ctx.tieTotal,
                confirmedBet: _ctx.tBet,
                betType: 3,
                height: 127,
                width: 396,
                mWidth: 10,
                mHeight: 10,
                ref: "tieTGBox",
                "show-flashing-bg": _ctx.isTieWin
              }, null, 8, ["label", "onPlaceBet", "tempBet", "totalBet", "confirmedBet", "show-flashing-bg"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ctrl_bet_box, {
                class: "bet-view-r-item",
                color: 1,
                label: _ctx.t('game.dragon'),
                ratio: "1:1",
                onPlaceBet: _ctx.placeBet,
                tempBet: _ctx.tempDrBet,
                totalBet: _ctx.bankerTotal,
                confirmedBet: _ctx.drBet,
                betType: 4,
                width: 198,
                height: 127,
                mWidth: 10,
                mHeight: 10,
                ref: "dragonBox",
                "show-flashing-bg": _ctx.isBlueWin
              }, null, 8, ["label", "onPlaceBet", "tempBet", "totalBet", "confirmedBet", "show-flashing-bg"]),
              _createVNode(_component_ctrl_bet_box, {
                class: "bet-view-r-item",
                color: 3,
                label: _ctx.t('game.tiger'),
                ratio: "1:1",
                onPlaceBet: _ctx.placeBet,
                tempBet: _ctx.tempTgBet,
                totalBet: _ctx.playerTotal,
                confirmedBet: _ctx.tgBet,
                betType: 5,
                width: 198,
                height: 127,
                mWidth: 10,
                mHeight: 10,
                ref: "tigerBox",
                "show-flashing-bg": _ctx.isRedWin
              }, null, 8, ["label", "onPlaceBet", "tempBet", "totalBet", "confirmedBet", "show-flashing-bg"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9)),
    (_ctx.showStartAndEndNorify)
      ? (_openBlock(), _createBlock(_component_bet_start_stop_pop, {
          key: 3,
          status: _ctx.timerNotifyStatus,
          class: "start-or-stop-game",
          onHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showStartAndEndNorify = false))
        }, null, 8, ["status"]))
      : _createCommentVNode("", true),
    (_ctx.totalTempBet > 0 && !_ctx.isBetOnProcess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "btn-cancel",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetTempBet && _ctx.resetTempBet(...args)))
          }, [
            _createVNode(_component_cancel_bet, {
              text: _ctx.t('game.cancelbet')
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", {
            class: "btn-confirm",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmTempBet && _ctx.confirmTempBet(...args)))
          }, [
            _createVNode(_component_confirm_bet, {
              text: _ctx.t('game.confirmbet')
            }, null, 8, ["text"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_TransitionGroup, {
        class: "toast-container",
        tag: "div",
        name: "list",
        appear: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toastMessage, (toast, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "toast",
              key: index
            }, [
              _createElementVNode("span", null, _toDisplayString(toast.message), 1)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}